<template>
  <div>
      <MasterHeader
        v-bind:classHeader="'registration'"
        v-bind:classGrid="'wp1200'"/>
    <section>
      <div class="wp800">
        <div class="onBoardRegistrationTwo completeReg">
          <div class="flex">
            <div class="col1_2">
              <img class="leftImage" src="@/assets/images/completeRegistration.png" />
            </div>
            <div class="col1_2 text">
              <h2>
                <span>
                  {{ $t("registration.title3") }}
                  <br />
                </span>{{ $t("registration.title4") }}
              </h2>
              <hr class="lightBlue" />
              <p>
                {{ $t("registration.text2") }}
              </p>
              <a href="/login"
                class="join smallFont hoverEffect"

              >
                <label>{{ $t("registration.link2") }}</label>
                <span
                  class="effect"
                  ref="effectButton1"
                  v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"
                ></span>
                <img src="@/assets/images/nextArrowAnimation.svg" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import MasterHeader from '../partials/MasterHeader';
export default {
  data() {
    return {
      onboardingUrl: "",
      topX: 1,
      leftX: 1,
      notCompleted: true,
    };
  },
  created() {
    this.onboardingUrl = this.$route.params.onboardingUrl;
  },
  components: {
    MasterHeader
  },
  mounted() {},
  methods: {
    startOnBoarding() {
      console.log("startOnBoarding" + this.onboardingUrl);
    },
  },
};
</script>
<style>
</style>